export default [
	{
		path: '/dataList/inventory',
		component: (resolve) => require(['../page.vue'], resolve),
		meta: {
			title: '库存管理',
			authLogin: true,
		},
	},
]
